import {
  isString,
  isNumber
} from './helper/index.js';

/**
 * json path library
 *
 * p := "" | "." | item
 * p := p "." p
 */

const back = (jsonPath, dis = 1) => {
  const keys = getItems(jsonPath);
  for (let i = 0; i < dis; i++) {
    if (keys.length === 0) {
      break;
    }
    keys.pop();
  }
  return keys.join('.');
};

const next = (jsonPath, ...strs) => {
  return [jsonPath, ...strs].join('.');
};

const getItems = (jsonPath) => {
  return jsonPath.split('.').map(v => v.trim()).filter((v) => !!v);
};

const getLast = (jsonPath) => {
  const items = getItems(jsonPath);
  return items[items.length - 1];
};

const format = (jsonPath) => {
  return getItems(jsonPath).join('.');
};

const append = (jsonPath, nextPath = '') => {
  if (jsonPath === '') {
    return nextPath;
  }
  return `${jsonPath}.${nextPath}`;
};

function JsonPath(items = []) {
  this.items = items;
}

JsonPath.prototype.next = function(...keys) {
  const items = this.items.slice(0);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if (!isString(key) && !isNumber(key)) {
      throw new Error(`unexpected key ${key}`);
    }
    const ks = getItems(key + '');
    items.push(...ks);
  }
  return new JsonPath(items);
};

JsonPath.prototype.back = function(dis = 1) {
  const items = this.items.slice(0);
  for (let i = 0; i < dis; i++) {
    if (items.length === 0) {
      break;
    }
    items.pop();
  }

  return new JsonPath(items);
};

JsonPath.prototype.toString = function() {
  return this.items.join('.');
};

export {
  back,
  next,
  getItems,
  getLast,
  format,
  append,
  JsonPath,
};
